import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import HeroSection from './components/HeroSection';
import MarqueeBar from './components/MarqueeBar';
import HotGossip from './components/HotGossip';
import CategorySection from './components/CategorySection';
import EditorPicks from './components/EditorPicks';
import LatestFeed from './components/LatestFeed';
import FaqSection from './components/FaqSection';
import BrandSection from './components/BrandSection';
import SubscribeSection from './components/SubscribeSection';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '糖心吃瓜',
      url: 'https://lhyf56.cn/',
      description: '专注甜向内容的吃瓜小站，收罗恋爱小料、心动瞬间、官宣现场与情侣小事。',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://lhyf56.cn/fresh?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '糖心吃瓜',
      url: 'https://lhyf56.cn/',
      description: '只磕甜向小瓜的娱乐内容站',
      email: 'hello@tangxinchigua.com',
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '糖心吃瓜只发甜甜的内容吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的。糖心吃瓜只磕甜向小瓜，恋爱小料、心动瞬间、官宣现场与情侣小事是我们的四大板块，刻意避开让人心里发闷的料。',
          },
        },
        {
          '@type': 'Question',
          name: '这里的瓜料来源可靠吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '站内内容均来自公开渠道的整理与二次创作，我们会在每篇瓜料里标注整理时间与来源标签。',
          },
        },
        {
          '@type': 'Question',
          name: '多久更新一次新瓜？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '编辑组工作日上午会集中上新，遇到热度高的官宣现场和心动瞬间会随时加更。',
          },
        },
        {
          '@type': 'Question',
          name: '可以投稿自己的甜味瓜吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '可以。我们欢迎真实、温暖、不涉及隐私细节的恋爱小事投稿。',
          },
        },
        {
          '@type': 'Question',
          name: '订阅甜瓜日报会收到什么？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '每天一封邮件，精选当天最甜的三条瓜料加一句小感想，不推送广告，随时可以退订。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <title>糖心吃瓜 - 恋爱小料、心动瞬间与官宣现场，专磕甜向小瓜</title>
      <meta
        name="description"
        content="糖心吃瓜是专注甜向内容的吃瓜小站，收罗恋爱小料、心动瞬间、官宣现场与情侣小事，把不扎心的甜味瓜整理成清爽好读的甜瓜田。"
      />
      <meta name="keywords" content="糖心吃瓜,恋爱小料,心动瞬间,官宣,情侣小事,甜味瓜" />
      <link rel="canonical" href="https://lhyf56.cn/" />
      <meta property="og:title" content="糖心吃瓜 - 专磕甜向小瓜" />
      <meta property="og:description" content="恋爱小料、心动瞬间、官宣现场与情侣小事一网打尽，每一条都让人嘴角上扬。" />
      <meta property="og:url" content="https://lhyf56.cn/" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      <SiteHeader />
      <main>
        <HeroSection />
        <MarqueeBar />
        <HotGossip />
        <CategorySection />
        <EditorPicks />
        <LatestFeed />
        <FaqSection />
        <BrandSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}